import React, { useState } from "react";
import Header from "./Header/Header.index";
import Footer from "./Footer/MainFooter.index";
import {
  CommonBlockBox,
  CommonLayout,
  MyPageLayoutWrapper,
  MobileFooterToggle,
  FooterContainer,
} from "./MainLayout.style";

const MainLayout = ({ children, hideMobileMenu = false }) => {
  const [showFooter, setShowFooter] = useState(() => {
    return localStorage.getItem("showMainFooter") !== "false";
  });

  const toggleFooter = () => {
    setShowFooter((prev) => {
      localStorage.setItem("showMainFooter", String(!prev));
      return !prev;
    });
  };

  return (
    <MyPageLayoutWrapper>
      <Header />

      <CommonLayout>
        <CommonBlockBox>{children}</CommonBlockBox>
      </CommonLayout>

      {!hideMobileMenu && (
        <MobileFooterToggle
          type="button"
          onClick={toggleFooter}
          title={showFooter ? "Footerを非表示" : "Footerを表示"}
          aria-label={showFooter ? "Footerを非表示" : "Footerを表示"}
        >
          {showFooter ? "M隠" : "M出"}
        </MobileFooterToggle>
      )}

      <FooterContainer showFooter={showFooter && !hideMobileMenu}>
        <Footer />
      </FooterContainer>
    </MyPageLayoutWrapper>
  );
};

export default MainLayout;
